import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  private title: string = '';
  constructor(private titleService: Title) {}

  public getTitle(): string {
    return this.title;
  }
  public setTitle(title: string) {
    if (title && title.length) {
      this.titleService.setTitle('CREAWeb - ' + title);
    } else {
      this.titleService.setTitle('CREAWeb');
    }
    this.title = title;
  }
}
